import { httpClient } from '@ahm/api-wrappers-core';
import type { AxiosRequestConfig } from 'axios';
import { apiRoutes } from '@/api/api-routes';

export type CancelOrderRequestBody = {
  order_id: string;
  cancel_code: string;
  comment: string;
  rebroadcast?: boolean;
};

export type CancelOrderOptions = {
  isPartner?: boolean;
} & AxiosRequestConfig;

export const cancelOrderFn = async (
  body: CancelOrderRequestBody,
  options: CancelOrderOptions = {}
) => {
  const { isPartner = false, ...config } = options;

  const requestConfig = {
    ...config,
  };

  const endpoint = isPartner
    ? apiRoutes.order.cancelPartner
    : apiRoutes.order.cancel;

  const response = await httpClient.put<NonNullable<unknown>>(
    endpoint,
    body,
    requestConfig
  );

  return response.data;
};

// Legacy function for backward compatibility
export const cancelOrderPartnerFn = async (
  body: CancelOrderRequestBody,
  config: AxiosRequestConfig = {}
) => {
  return cancelOrderFn(body, { ...config, isPartner: true });
};
